import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import RootApp from "./App";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance, loginRequest, b2cPolicies } from "./utils/msalConfig";
import { getProfileAPI } from "./utils/api";

/* ---------- PDF.js worker ---------- */
import { pdfjs } from "react-pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

/* ---------- MSAL bootstrap con manejo de reset password ---------- */
async function initializeAuth() {
  await msalInstance.initialize();

  try {
    const response = await msalInstance.handleRedirectPromise();

    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    }

    // Manejar error por usuario que olvidó su contraseña (AADB2C90118)
    if (!response && !msalInstance.getActiveAccount()) {
      await msalInstance.loginRedirect(loginRequest);
      return false;
    }

  } catch (error) {
    if (
      error.errorMessage?.includes("AADB2C90118")
    ) {
      // Usuario seleccionó "Forgot your password?" → redirigir a flujo de recuperación
      const passwordResetRequest = {
        authority: b2cPolicies.authorities.passwordReset.authority,
        scopes: loginRequest.scopes,
      };

      await msalInstance.loginRedirect(passwordResetRequest);
      return false;

    } else if (
      error.errorMessage?.includes("AADB2C90091")
    ) {
      // Usuario canceló el proceso de recuperación → volver al login principal
      console.warn("The user canceled the password recovery process.");
      await msalInstance.loginRedirect(loginRequest);
      return false;

    } else {
      console.error("Authentication error:", error);
      return false;
    }
  }

  try {
    await getProfileAPI(); // opcional pero útil
  } catch (e) {
    console.error("Error calling /me/profile:", e);
  }

  msalInstance.enableAccountStorageEvents();
  return true;
}

/* ---------- Renderizado raíz ---------- */
initializeAuth().then((ok) => {
  if (ok) {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <MsalProvider instance={msalInstance}>
        <RootApp pca={msalInstance} />
      </MsalProvider>
    );
  }
});
